module.exports = __webpack_public_path__ + "img/perphoto.482e668c.png";